/**
 * Light/dark mode switch.
 * Colors are NOT set here: snippets/p3-tokens.liquid owns every value and reacts to
 * html[data-theme]. This file only stores the choice and flips the attribute.
 */
(function () {
  var KEY = 'vc-theme';
  var root = document.documentElement;

  function systemTheme() {
    try {
      return window.matchMedia('(prefers-color-scheme: light)').matches ? 'light' : 'dark';
    } catch (e) {
      return 'dark';
    }
  }

  function stored() {
    try {
      var v = localStorage.getItem(KEY);
      return v === 'light' || v === 'dark' ? v : null;
    } catch (e) {
      return null;
    }
  }

  function syncButtons(theme) {
    var btns = document.querySelectorAll('.p3-theme-toggle');
    for (var i = 0; i < btns.length; i++) {
      btns[i].setAttribute('aria-pressed', theme === 'light' ? 'true' : 'false');
    }
  }

  function apply(theme, persist) {
    root.setAttribute('data-theme', theme);
    if (persist) {
      try {
        localStorage.setItem(KEY, theme);
      } catch (e) {}
    }
    syncButtons(theme);
  }

  function current() {
    return root.getAttribute('data-theme') || stored() || systemTheme();
  }

  function init() {
    apply(current(), false);
    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('.p3-theme-toggle') : null;
      if (!btn) return;
      e.preventDefault();
      apply(current() === 'light' ? 'dark' : 'light', true);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  window.addEventListener('storage', function (e) {
    if (e.key === KEY && (e.newValue === 'light' || e.newValue === 'dark')) {
      apply(e.newValue, false);
    }
  });
})();
